/**
 * Constants defining the different types of nodes available in workflows.
 * Used for type checking and node identification throughout the workflow system.
 */
export const NODE_TYPES = {
  SCORECARD_SET: "ScorecardsetNode",
  RULESET: "RulesetNode",
  PROGRAM: "ProgramNode",
  DECISION: "DecisionNode",
  START: "StartNode",
  PROJECT: "ProjectNode",
  SCRIPT: "ScriptNode",
  TAGLIST: "TaglistNode",
  CALCULATOR: "CalculatorNode",
  END_RESULT: "EndResultNode",
  FILTER: "FilterNode",
  LOOP_START: "LoopStartNode",
  LOOP_END: "LoopEndNode",
  MARKETPLACE_SCRIPT: "MarketPlaceScriptNode",
  LABEL: "LabeledNode",
} as const
